module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dqhCmk/tc-custom/9781467436847.jpg?1728851792691",
      "alt": "This image is the cover for the book Salty Wives, Spirited Mothers, and Savvy Widows"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Salty Wives, Spirited Mothers, and Savvy Widows\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Engaging feminist hermeneutics and philosophy in addition to more traditional methods of biblical study, "), _c('i', [_vm._v("Salty Wives, Spirited Mothers, and Savvy Widows")]), _vm._v(" demonstrates and celebrates the remarkable capability and ingenuity of several women in the Gospel of Luke. While recent studies have exposed women's limited opportunities for ministry in Luke, Scott Spencer pulls the pendulum back from a negative feminist-critical pole toward a more constructive center."), _c('br'), _c('br'), _vm._v(" Granting that Luke sends somewhat \"mixed messages\" about women's work and status as Jesus' disciples, Spencer analyzes such women as Mary, Elizabeth, Joanna, Martha and Mary, and the infamous yet intriguing wife of Lot -- whom Jesus exhorts his followers to \"remember\" -- as well as the unrelentingly persistent women characters in Jesus' parables.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      F. Scott Spencer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("F. Scott Spencer is professor of New Testament and preaching at Baptist Theological Seminary, Richmond, Virginia. His other books include "), _c('em', [_vm._v("Dancing Girls, Loose Ladies, and Women of the Cloth")]), _vm._v(" and "), _c('em', [_vm._v("The Gospel of Luke and Acts of the Apostles")])])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0